export enum MediaType {
  PaidSearch = 1,
  Contextual = 2,
  MobileSearch = 3,
  MobileContextual = 4,
  Display = 5,
  WindowsApp = 6,
  Native = 10,
  AudienceAds = 11,
  LinkedInAds = 12,
}

export const MediaTypeString = {
  PaidSearch: 'PaidSearch',
  MobilePaidSearch: 'MobilePaidSearch',
  Native: 'Native',
  AudienceAds: 'AudienceAds',
  LinkedInAds: 'LinkedInAds',
};
